import React from 'react';
import Footer from '../components/footer/index';
import Section from '../components/produk/banner';
import Promo from '../components/produk/promo';
import ProdukDiskon from '../components/produk/produk_diskon';
import Keunggulan from '../components/produk/keunggulan';
import BannerUpggrade from '../components/produk/banner_upgrade';
import { useDarkMode } from '../components/darkmode/DarkModeContext';

const InternetPackagesPage = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <div
      className="min-h-screen bg-cover bg-center transition-colors duration-300 pt-16"
      style={{
        backgroundImage: "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay'
      }}
    >
      <Section />
      <Promo />
      <ProdukDiskon />
      <Keunggulan />
      <BannerUpggrade />
      <Footer />
    </div>
  );
};

export default InternetPackagesPage;